import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'vx-demo-form',
  standalone: true,
  imports: [ReactiveFormsModule],
  template: `
    <form [formGroup]="form" (ngSubmit)="submit()" class="demo-form card">
      <div class="form-field"><label>Nome</label><input formControlName="nome" placeholder="Mario Rossi"></div>
      <div class="form-field"><label>Azienda / ente</label><input formControlName="azienda" placeholder="Comune, hotel, societa"></div>
      <div class="form-field"><label>Ruolo</label><input formControlName="ruolo" placeholder="Innovation manager"></div>
      <div class="form-field"><label>Email</label><input formControlName="email" type="email" placeholder="nome@azienda.it"></div>
      <div class="form-field"><label>Telefono</label><input formControlName="telefono" placeholder="+39"></div>
      <div class="form-field"><label>Tipologia interesse</label><select formControlName="interesse"><option>Smart City</option><option>Hotel e turismo</option><option>Spiagge</option><option>Eventi</option><option>Stazioni e aeroporti</option></select></div>
      <div class="form-field wide"><label>Messaggio</label><textarea formControlName="messaggio" rows="5"></textarea></div>
      <label class="privacy wide"><input type="checkbox" formControlName="privacy_accepted"> Accetto il trattamento dei dati per essere ricontattato.</label>
      @if (error()) { <p class="error wide">{{ error() }}</p> }
      @if (sent()) { <p class="success wide">Richiesta inviata. Il team VaulTriX ti ricontattera per una demo.</p> }
      <button class="btn primary wide" type="submit" [disabled]="form.invalid">Richiedi una demo</button>
    </form>
  `,
  styles: [`
    .demo-form {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px;
      align-items: start;
    }
    .wide {
      grid-column: 1 / -1;
    }
    .privacy {
      color: var(--vx-muted);
      font-weight: 700;
      display: flex;
      gap: 10px;
      align-items: center;
    }
    .error { color: var(--vx-danger); margin: 0; font-weight: 800; }
    .success { color: #15803d; margin: 0; font-weight: 800; }
    button:disabled {
      cursor: not-allowed;
      opacity: 0.58;
      transform: none;
      box-shadow: none;
    }
    @media (max-width: 680px) {
      .demo-form { grid-template-columns: 1fr; }
    }
  `]
})
export class DemoFormComponent {
  private readonly fb = inject(FormBuilder);
  private readonly api = inject(ApiService);
  protected readonly sent = signal(false);
  protected readonly error = signal('');

  protected readonly form = this.fb.nonNullable.group({
    nome: ['', Validators.required],
    azienda: ['', Validators.required],
    ruolo: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    telefono: [''],
    interesse: ['Smart City', Validators.required],
    messaggio: ['', [Validators.required, Validators.minLength(10)]],
    privacy_accepted: [false, Validators.requiredTrue]
  });

  submit() {
    this.error.set('');
    this.sent.set(false);
    if (this.form.invalid) {
      this.error.set('Completa i campi obbligatori e accetta la privacy.');
      this.form.markAllAsTouched();
      return;
    }
    this.api.createDemoRequest(this.form.getRawValue()).subscribe(() => {
      this.sent.set(true);
      this.form.reset({ interesse: 'Smart City', privacy_accepted: false });
    });
  }
}
